import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';

export default function ConfirmDialog({
  open,
  title = 'Confirmer',
  message = 'Êtes-vous sûr ?',
  confirmLabel,
  cancelLabel = 'Annuler',
  destructive = false,
  loading = false,
  loadingLabel,
  onConfirm,
  onCancel,
}) {
  const resolvedConfirm =
    confirmLabel
    ?? (destructive ? 'Supprimer définitivement' : 'Confirmer');

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown={loading}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={loading} sx={{ minHeight: 44 }}>
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          color={destructive ? 'error' : 'primary'}
          variant="contained"
          sx={{ minHeight: 44, minWidth: 120 }}
          startIcon={
            loading ? <CircularProgress color="inherit" size={18} /> : undefined
          }
        >
          {loading ? (loadingLabel || 'Traitement…') : resolvedConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
